import { Td } from '../../../../components/PdfExportV2/Td/Td.tsx';
import { Text } from '../../../../components/PdfExportV2/Text/Text.tsx';
import { Tr } from '../../../../components/PdfExportV2/Tr/Tr.tsx';
import { BORDER } from '../consts.ts';
import { textStyleOverrides } from './consts.ts';
import { ExportCostApproachData } from './types.ts';
import { makeColSpan } from './utils/makeColSpan.ts';

export const ExportCostApproachDepreciationRows = ({
  data,
  hasExternalDepreciation,
  hasFunctionalDepreciation,
}: {
  data: ExportCostApproachData;
  hasExternalDepreciation: boolean;
  hasFunctionalDepreciation: boolean;
}) => {
  const totalDepreciationColumns =
    1 + (hasFunctionalDepreciation ? 1 : 0) + (hasExternalDepreciation ? 1 : 0);

  const colSpan = 6 / totalDepreciationColumns;

  return (
    <>
      <Tr>
        <Td style={{ borderLeft: BORDER, width: makeColSpan(0, 1) }}>
          <Text variant="body1" {...textStyleOverrides}>
            Less
          </Text>
        </Td>
        <Td style={{ width: makeColSpan(1, colSpan) }}>
          <Text variant="body1" {...textStyleOverrides}>
            Physical
          </Text>
        </Td>
        {hasFunctionalDepreciation && (
          <Td style={{ width: makeColSpan(3, colSpan) }}>
            <Text variant="body1" {...textStyleOverrides}>
              Functional
            </Text>
          </Td>
        )}
        {hasExternalDepreciation && (
          <Td style={{ width: makeColSpan(5, colSpan) }}>
            <Text variant="body1" {...textStyleOverrides}>
              External
            </Text>
          </Td>
        )}
        <Td style={{ width: makeColSpan(7, 1) }}>
          <Text variant="body1" {...textStyleOverrides}>
            {''}
          </Text>
        </Td>
      </Tr>
      <Tr>
        <Td style={{ borderLeft: BORDER, width: makeColSpan(0, 1) }}>
          <Text variant="body1" {...textStyleOverrides}>
            {''}
          </Text>
        </Td>
        <Td style={{ width: makeColSpan(1, colSpan) }}>
          <Text variant="body1" {...textStyleOverrides}>
            {data.physicalDepreciation?.toString(true) ?? ''}
          </Text>
        </Td>
        {hasFunctionalDepreciation && (
          <Td style={{ width: makeColSpan(3, colSpan) }}>
            <Text variant="body1" {...textStyleOverrides}>
              {data.functionalDepreciation?.toString(true) ?? ''}
            </Text>
          </Td>
        )}
        {hasExternalDepreciation && (
          <Td style={{ width: makeColSpan(5, colSpan) }}>
            <Text variant="body1" {...textStyleOverrides}>
              {data.externalDepreciation?.toString(true) ?? ''}
            </Text>
          </Td>
        )}
        <Td style={{ width: makeColSpan(7, 1) }} textAlign="right">
          <Text variant="body1" {...textStyleOverrides}>{`= ${data.depreciation}`}</Text>
        </Td>
      </Tr>
    </>
  );
};
